module.exports = __webpack_public_path__ + "media/great.2ccc60df.mp3";